import { render, staticRenderFns } from "./DigitalDownloadDelivery.vue?vue&type=template&id=53e05f6a"
import script from "./DigitalDownloadDelivery.vue?vue&type=script&lang=js"
export * from "./DigitalDownloadDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports